import { shouldMock } from '@/lib/utils';
import { notification } from 'antd';
import ky from 'ky';
import { useSearchParams } from 'next/navigation';

export function useHubSpotKy() {
  const search = useSearchParams();
  const token = search.get('token');
  if (!token && !shouldMock) notification.error({ message: 'Unauthorized' });
  const baseUrl = process.env.NEXT_PUBLIC_HUBSPOT_BACKEND_DOMAIN?.trim();
  return ky.create({
    prefixUrl: `https://${baseUrl}/api/rest/hubspot`,
    headers: {
      Authorization: token + '',
      'X-HubSpot-Signature-Version': 'hubspot-iframe',
    },
  });
}

export function useHubspotCustomerKy() {
  const hubKy = useHubSpotKy();
  const search = useSearchParams();
  return hubKy.extend((options) => ({
    prefixUrl: `${options.prefixUrl}/customer/${search.get('customerId')}`,
  }));
}
